  async function updateCartDrawer() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_drawer").innerHTML;
  document.querySelector(".u_cart_drawer").innerHTML = newBox;
}
  async function updateCartDrawer2() {
  const res = await fetch("/?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".u_cart_bar_wrapper").innerHTML;
  document.querySelector(".u_cart_bar_wrapper").innerHTML = newBox;
}
$(function(){
  function getCartCount() {
    $.getJSON('/cart.js', function(cart){ 
      var result = cart.item_count;
      console.log(result);
      $('.cart-link__count').text(result);
      });
    }
  $(document).on('change','.u_upp_var_select',function(){
    let selected_val = $(this).find('option:selected').val().trim()
    console.log('selected value',selected_val)
    $(this).closest('.product-block').find('.u_upp_pro_atc').attr('var-id',selected_val)
  })
    $(document).on('click','.u_upp_pro_atc',function(){
     let variant_id = $(this).attr('var-id').trim()
    let ths = $(this);
     $.ajax({
        type:'POST',
        url:'/cart/add.js',
         data : {
        "id": variant_id,
        "quantity": 1,        
      },
 dataType: 'json',
        success: function(result){
        console.log('add to cart');

      },
         beforeSend: function() {
       ths.closest('.product-block').find('.u_cart_btn_val').addClass('active');
ths.closest('.product-block').find('.u_loading_state').addClass('active');
         },
                    error: function(err) {
               console.log('error',err)
      },
         complete: function() {
                      console.log('complete');
           updateCartDrawer();
           setTimeout(function(){
             getCartCount();
                        $('.cart-link__icon').trigger('click')
           },1500)
                  ths.closest('.product-block').find('.u_cart_btn_val').removeClass('active');
ths.closest('.product-block').find('.u_loading_state').removeClass('active');

      }
    })
    })
  $(document).on('click','.js-close-drawer,.overlay',function(){
     $('.u_cart_drawer').removeAttr('open')
              $('.overlay').removeClass('is-visible')
  })
  $(document).on('click','.u_bundle_atc',function(e){
    e.preventDefault()
    console.log('rook')
     let ths = $(this);
    let bundle_data = $(this).closest('form').serialize();
    console.log('bundle_data',bundle_data)
        $.ajax({
        type:'POST',
        url:'/cart/add.js',
         data :bundle_data,
 dataType: 'json',
        success: function(result){
        console.log('add to cart');

      },
         beforeSend: function() {
                  ths.closest('.u_bundle_atc').find('.u_cart_btn_val').addClass('active');
ths.closest('.u_bundle_atc').find('.u_loading_state').addClass('active');
         },
                    error: function(err) {
               console.log('error',err)
      },
         complete: function() {
                      console.log('complete');
           updateCartDrawer();
           setTimeout(function(){
             getCartCount();
                        $('.cart-link__icon').trigger('click')
             
           },1500)
                      ths.closest('.u_bundle_atc').find('.u_cart_btn_val').removeClass('active');
ths.closest('.u_bundle_atc').find('.u_loading_state').removeClass('active');

      }
    })
  })
  $(document).on('click','.quantity-up,.quantity-down,.add-to-cart,.u_bundle_atc',function(){
       
    console.log('clickk')
  setTimeout(function(){
                      updateCartDrawer2();
  },1500)
  })
})